import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogDetailPage } from '@/features/data/catalog/catalog-detail-page';
import { catalogSearch } from '@/features/data/catalog/catalog-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Une couche : ses bases (onglet par défaut), son résumé, sa définition. Onglet dans l'URL. */
export const Route = createFileRoute('/$tenant/catalog/$layer/')({
  validateSearch: catalogSearch,
  component: LayerRoute,
});

function LayerRoute() {
  const { tenant, layer } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[{ label: t('nav.items.catalog') }, { label: layer, mono: true }]}
    >
      <CatalogDetailPage
        tenantId={tenant}
        path={{ level: 'layer', layer }}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
